<template>
    <div>
        <el-dialog :title="$t('editAwards')"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   @close="dialogClose"
                   center
                   top="10vh"
                   custom-class="large-dialog">
            <div class="content">
                <h4 class="content-title">{{ lotteryPeriodName }}</h4>
                <el-form :model="formData"
                         size="mini"
                         :rules="rules"
                         ref="ruleForm"
                         label-width="110px">
                    <div class="form-two">
                        <el-form-item :label="$t('awardsName')"
                                      prop="name">
                            <el-input v-model="formData.name"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item class="form-item-info"
                                      :label="$t('prize')"
                                      prop="awardId">
                            <el-select v-model="formData.awardId"
                                       filterable
                                       @change="prizeChange">
                                <el-option v-for="prizeItem in prizeOptions"
                                           :key="prizeItem.id"
                                           :label="prizeItem.name"
                                           :value="prizeItem.id">
                                </el-option>
                            </el-select>
                            <el-popover placement="right"
                                        min-width="400"
                                        trigger="hover"
                                        v-if="formData.awardId">
                                <div class="info-card">
                                    <p class="info-item">{{$t('prizeName')}}: {{ prize.name }}</p>
                                    <p class="info-item"
                                       v-if="prize.type === 101">{{$t('prizeType')}}: {{$t('inKind')}}</p>
                                    <p class="info-item"
                                       v-else-if="prize.type === 102">{{$t('prizeType')}}: {{$t('virtual')}}</p>
                                    <p class="info-item">{{$t('price')}}: {{ prize.faceValue }}</p>
                                    <p class="info-item">{{$t('postage')}}: {{ prize.postage }}</p>
                                </div>
                                <i class="el-icon-info"
                                   slot="reference"></i>
                            </el-popover>
                        </el-form-item>
                    </div>
                    <div class="form-two">
                        <el-form-item :label="$t('invalidTime')"
                                      prop="awardInvalidAt">
                            <el-date-picker v-model="formData.awardInvalidAt"
                                            type="date"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            time-arrow-control
                                            :placeholder="$t('pleaseSelectHint')">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item :label="$t('sortValue')"
                                      prop="sort">
                            <el-input type="number"
                                      v-model="formData.sort"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="group">
                    <div class="group-header">
                        <span class="label">{{ $t('awards') }}</span>
                        <el-button type="primary"
                                   size="mini"
                                   @click="addAwardsHandle">{{ $t('add') }}</el-button>
                    </div>
                    <el-form v-for="(item, index) in awardsForm.list"
                             :key="index"
                             :model="item"
                             size="mini"
                             :ref="`awardsForm${index}`"
                             :rules="rules"
                             label-width="110px">
                        <div class="form-multi">
                            <el-form-item :label="$t('winningCode')"
                                          prop="code">
                                <el-input v-model="item.code"
                                          disabled>
                                    <template slot="append">
                                        <el-button slot="append"
                                                   @click="generateCodeHandle(index)">{{ $t('generate') }}</el-button>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item :label="$t('shop')"
                                          prop="shopName">
                                <el-input v-model="item.shopName"
                                          clearable
                                          @clear="clearShopHandle(index)">
                                    <template slot="append">
                                        <el-button slot="append"
                                                   @click="selectShopHandle(index)">{{ $t('select') }}</el-button>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <div class="form-handle">
                                <i class="el-icon-delete red"
                                   @click="deleteAwardsHandle(index)"
                                   v-if="!item.open"></i>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
            <div slot="footer"
                 class="dialog-footer">
                <el-button size="mini"
                           @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
                <el-button type="primary"
                           size="mini"
                           :disabled="disabled"
                           @click="submitForm('ruleForm')">{{ $t('confirm') }}</el-button>
            </div>
        </el-dialog>
        <!-- PointsMe 门店 -->
        <PointsMeShop :parent-dialog="shopDialog"
                      @parent-update="shopUpdate"
                      @parent-close="shopDialog = false" />
    </div>

</template>

<script>
import {
    updateLotteryAwards,
    searchLotteryPrizeList,
    queryLotteryAwardsDetails,
    generateLotteryAwardsCode
} from "@/api/modules/api";
import { mapState } from "vuex";
import PointsMeShop from "@/components/common/PointsMeShop";

export default {
    name: 'Edit',
    components: {
        PointsMeShop
    },
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            dialogVisible: false,
            formData: {
                name: '',
                awardId: '',
                awardInvalidAt: '',
                sort: 1,
            },
            awardsForm: {
                list: []
            },
            rules: {
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                awardId: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                awardInvalidAt: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                sort: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                // code: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                shopName: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
            },
            prizeOptions: [],
            prize: null,
            disabled: false,
            awardsIndex: 0,
            shopDialog: false
        }
    },
    created () { },
    mounted () { },
    computed: {
        ...mapState('other', ['lotteryPeriodId', 'lotteryPeriodName']),
    },
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            this.awardsForm.list = []
            // 获取详情
            this.getDetails()
            // 获取奖品列表
            if (this.prizeOptions.length === 0) {
                this.getPrizeOptions()
            }
        },

        // 获取详情
        getDetails () {
            queryLotteryAwardsDetails(this.parentId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    // 使用期限
                    let awardInvalidAt = this.$moment(resData.awardInvalidAt).format('YYYY-MM-DD')
                    this.formData = {
                        name: resData.name,
                        awardId: resData.awardId,
                        awardInvalidAt,
                        sort: resData.sort,
                    }
                    // 奖品信息
                    this.prize = resData.awardDepot
                    // 门店&抽奖码
                    let list = []
                    let winAwardCodes = resData.winAwardCodes || []
                    winAwardCodes.forEach(item => {
                        list.push(
                            {
                                id: item.id,
                                open: item.open,
                                code: item.code,
                                merchantId: item.merchantId,
                                merchantName: item.merchantName,
                                shopId: item.shopId,
                                shopName: item.shopName,
                                shopAddress: item.shopAddress,
                                shopLatitude: item.shopLatitude,
                                shopLongitude: item.shopLongitude
                            }
                        )
                    })
                    this.awardsForm.list = list
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },

        // 获取奖品列表
        getPrizeOptions () {
            const params = {
                enabled: true
            }
            searchLotteryPrizeList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.prizeOptions = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },

        // 切换奖品
        prizeChange (val) {
            let prize = this.prizeOptions.find(item => {
                return item.id === val
            })
            this.prize = prize
        },

        /******** 奖项 ********/
        // 添加奖项
        addAwardsHandle () {
            this.awardsForm.list.push({
                id: '',
                open: false,
                merchantId: '',
                merchantName: '',
                shopId: '',
                shopName: '',
                shopAddress: '',
                shopLatitude: '',
                shopLongitude: ''
            })
        },
        // 删除奖项
        deleteAwardsHandle (index) {
            // 删除项
            this.awardsForm.list.splice(index, 1)
        },

        // 生成奖项code
        generateCodeHandle (index) {
            const params = {
                activityId: this.lotteryPeriodId
            }
            generateLotteryAwardsCode(params).then(res => {
                if (Number(res.code) === 20000) {
                    let itemData = JSON.parse(JSON.stringify(this.awardsForm.list[index]))
                    itemData.code = res.data
                    this.$set(this.awardsForm.list, index, itemData)
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },

        // 选择门店
        selectShopHandle (index) {
            this.awardsIndex = index
            this.shopDialog = true
        },
        // 更新门店信息
        shopUpdate (data) {
            let shopData = JSON.parse(JSON.stringify(this.awardsForm.list[this.awardsIndex]))
            shopData.merchantId = data.merchantId
            shopData.merchantName = data.company.name
            shopData.shopId = data.id
            shopData.shopName = data.name
            if (data.address) {
                shopData.shopAddress = data.address.address
                shopData.shopLatitude = data.address.latitude
                shopData.shopLongitude = data.address.longitude
            } else {
                shopData.shopAddress = ''
                shopData.shopLatitude = ''
                shopData.shopLongitude = ''
            }
            this.$set(this.awardsForm.list, this.awardsIndex, shopData)
        },
        // 清除门店信息
        clearShopHandle (index) {
            let shopData = JSON.parse(JSON.stringify(this.awardsForm.list[index]))
            shopData.merchantId = ''
            shopData.merchantName = ''
            shopData.shopId = ''
            shopData.shopName = ''
            shopData.shopAddress = ''
            shopData.shopLatitude = ''
            shopData.shopLongitude = ''
            this.$set(this.awardsForm.list, index, shopData)
        },

        // 验证表单
        submitForm (formName) {
            Promise.all([
                this.validateBasicForm(formName),
                ...this.awardsForm.list.map((item, index) => this.validateAwardsForm(`awardsForm${index}`))
            ]).then((res) => {
                // 提交
                this.sendRequest()
            }).catch((err) => {
                return false
            })
        },

        // 校验基础表单
        validateBasicForm (formName) {
            return new Promise((resolve, reject) => {
                this.$refs[formName].validate(res => {
                    if (res) resolve()
                    else reject()
                })
            })
        },

        // 验证奖项表单
        validateAwardsForm (formName) {
            let valiForm = this.$refs[formName].validate ? this.$refs[formName] : this.$refs[formName][0]
            return new Promise((resolve, reject) => {
                valiForm.validate(res => {
                    if (res) resolve()
                    else reject()
                })
            })
        },

        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },

        // 提交
        sendRequest () {
            if (this.awardsForm.list.length === 0) {
                this.$message({
                    showClose: true,
                    message: this.$t('awardsNullHint'),
                    type: 'error'
                })
                return
            }
            // 使用期限
            let awardInvalidAt = this.$moment(this.formData.awardInvalidAt).format('YYYY-MM-DDTHH:mm:ssZZ')
            // 抽奖码&商家
            let winAwardCodes = []
            this.awardsForm.list.forEach((item, index) => {
                winAwardCodes.push({
                    id: item.id,
                    open: item.open,
                    code: item.code,
                    merchantId: item.merchantId,
                    merchantName: item.merchantName,
                    shopId: item.shopId,
                    shopName: item.shopName,
                    shopAddress: item.shopAddress,
                    shopLatitude: item.shopLatitude,
                    shopLongitude: item.shopLongitude
                })
            })
            const params = {
                activityId: this.lotteryPeriodId,
                id: this.parentId,
                name: this.formData.name.trim(),
                awardId: this.formData.awardId,
                awardInvalidAt,
                sort: this.formData.sort,
                winAwardCodes
            }
            this.disabled = true;
            updateLotteryAwards(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.dialogVisible = false
                    this.$emit('parent-update')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            }).finally(() => {
                this.disabled = false;
            })
        },
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/form-dialog.scss';
.content-title {
    height: 50px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
}
.el-icon-info {
    margin-left: 30px;
    cursor: pointer;
    font-size: 24px;
}
.group {
    margin-top: 10px;
    .group-header {
        padding-bottom: 10px;
        .label {
            margin-left: 10px;
            margin-right: 20px;
        }
    }
    ::v-deep .el-form {
        margin-bottom: 15px;
        .form-multi {
            width: 100%;
            display: flex;
            .el-form-item {
                width: 47%;
                .el-select {
                    width: 100%;
                }
            }
            .form-handle {
                flex-grow: 1;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                i {
                    font-size: 24px;
                    margin-right: 10px;
                    cursor: pointer;
                    &:last-of-type {
                        margin-right: 0;
                    }
                }
            }
        }
    }
}
</style>
